/**
 * Chart Legend Component
 *
 * Displays legend for the chart lines.
 */

import { CHART_COLORS } from "../constants";

interface ChartLegendProps {
  benchmarkName: string;
  fundName: string;
}

/**
 * Chart legend
 */
export function ChartLegend({ benchmarkName, fundName }: ChartLegendProps) {
  return (
    <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mt-4">
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-0.5 rounded-full"
          style={{ backgroundColor: CHART_COLORS.fund.stroke }}
        />
        <span className="text-xs text-muted-foreground">{fundName}</span>
      </div>
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-0 border-t border-dashed"
          style={{
            borderColor: CHART_COLORS.benchmark.stroke,
            borderWidth: 1.5,
          }}
        />
        <span className="text-xs text-muted-foreground">{benchmarkName}</span>
      </div>
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-0 border-t border-dashed"
          style={{
            borderColor: CHART_COLORS.invested.stroke,
            borderWidth: 1.5,
          }}
        />
        <span className="text-xs text-muted-foreground">Invested</span>
      </div>
    </div>
  );
}
